import { render, staticRenderFns } from "./OtherUserGroupTypeEdit.vue?vue&type=template&id=2868ea5a&scoped=true&lang=pug"
import script from "./OtherUserGroupTypeEdit.vue?vue&type=script&lang=ts"
export * from "./OtherUserGroupTypeEdit.vue?vue&type=script&lang=ts"
import style0 from "./OtherUserGroupTypeEdit.vue?vue&type=style&index=0&id=2868ea5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2868ea5a",
  null
  
)

export default component.exports